<template>
  <div>
    <div v-if="showClose" class="comp-close">
      <v-btn small text icon @click="close()" :disabled="!$auth.manage || isHistory">
        <icon-svg iconName="comp-close" />
      </v-btn>
    </div>
    <v-card class="proc-component">
      <v-card-title class="proc justify-center darken-1" @dblclick="openRightLayer()">
        <icon-svg :size="procIconSize" iconName="proc-folder" />
      </v-card-title>
    </v-card>
  </div>
</template>
<script>
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import { runSave } from '@/vue-caas/views/processnew/component/saveRunner.js';

export default {
  components: {
    IconSvg,
  },
  props: {
    comId: {
      default: '',
    },
    noteId: {
      default: '',
    },
    comTp: {
      default: 'DIR',
    },
    isHistory: {
      default: false,
    },

    subType: {
      default: 'SYSTEM',
    },
  },
  data() {
    return {
      procIconSize: 24,
      showClose: false,
      dirPath: '',
      foldId: '',
      formEmit: {
        comTp: 'DIR',
        comId: '',
        nodeId: '',
      },
      leftItems: {
        header: ['USER_ID'],
        data: [
          {
            USER_ID: '',
          },
        ],
      },
    };
  },
  watch: {
    comId() {
      return this.comId;
    },
  },
  created() {
    this.initialize();
  },
  mounted() {},
  methods: {
    resetForm() {
      this.dirPath = '';
      this.foldId = '';
      this.formEmit = {
        dirPath: this.dirPath,
        nodeId: this.nodeId,
        foldId: this.foldId,
        comId: this.foldId,
        comName: this.dirPath,
        comTp: this.comTp,
        foldList: this.foldList,
        systemFoldList: this.systemFoldList,
      };
      EventBus.$emit('set-dir-path', this.formEmit);
      EventBus.$emit('set-comp-id', this.formEmit);
    },
    openRightLayer() {
      EventBus.$emit('open-right-layer', this.formEmit);
    },
    initialize() {
      this.$nextTick(() => {
        this.nodeId = this.$el.parentElement.parentElement.id;
        this.foldId = this.comId;
        if (this.foldId !== '') {
          this.selectFolder();
        } else {
          this.addFolder();
        }
      });
    },
    selectFolder() {
      if (this.foldId) {
        let index = this.systemFoldList.findIndex((e) => e.FOLD_ID == this.foldId);
        if (index > -1) {
          this.dirPath = this.systemFoldList[index].FOLD_PATH;
          this.formEmit = {
            nodeId: this.nodeId,
            comId: this.foldId,
            comTp: this.comTp,
            foldId: this.foldId,
            foldList: this.foldList,
            systemFoldList: this.systemFoldList,
            dirPath: this.dirPath,
          };
          EventBus.$emit('set-dir-path', this.formEmit);
        }
      }
    },
    async addFolder() {
      const result = await runSave(this, 'DIR', { mode: 'form', data: null, subType: 'SYSTEM' });
      if (!result.success) {
        console.log(result.message);
      }
    },
    close() {
      EventBus.$emit('close', this.nodeId);
    },
  },
  computed: {
    foldList() {
      let data = [];
      this.$store.getters.foldList.forEach((e) => {
        if (e.FOLD_PA_ID === '0000000000' && e.FOLD_NAME === 'SYSTEM_' + e.FOLD_ID) {
          // this.systemFoldList.push(e);
        } else {
          data.push(e);
        }
      });
      return data;
    },
    systemFoldList() {
      let data = [];
      this.$store.getters.foldList.forEach((e) => {
        if (e.FOLD_PA_ID === '0000000000' && e.FOLD_NAME === 'SYSTEM_' + e.FOLD_ID) {
          data.push(e);
        }
      });
      return data;
    },
  },
};
</script>
